import React, { useEffect, useState } from 'react';
import { RecordData, aujourdhui } from './RecordData.tsx';
import { TextField, Select, MenuItem, FormControl, InputLabel, Button, Box } from '@mui/material';

export const RecordForm: React.FC<{ onSubmit?: (data: RecordData) => void; initialData?: RecordData }> = ({ onSubmit, initialData }) => {
  const [type, setType] = useState<string>(initialData?.type ?? 'RECUPERATION');
  const [hour, setHour] = useState<number>(initialData?.hour ?? 3);
  const [minute, setMinute] = useState<number>(initialData?.minute ?? 10);
  const [second, setSecond] = useState<number>(initialData?.second ?? 30);
  // Date du nouveau record : aujourd'hui par defaut (le formulaire sert a
  // saisir un nouveau record, pre-rempli avec le temps du record courant).
  const [date, setDate] = useState<string>(aujourdhui());

  useEffect(() => {
    if (initialData) {
      setType(initialData.type);
      setHour(initialData.hour);
      setMinute(initialData.minute);
      setSecond(initialData.second);
    }
  }, [initialData]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const data = { type, hour, minute, second, date };
    if (onSubmit) onSubmit(data);
  };

  return (
    <form onSubmit={handleSubmit}>
        
      <div>
            Saisis un nouveau record de course (il est ajouté à ton historique et permet de calculer tes allures d'entrainement).:
      </div>
      <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 300 }}>
          <InputLabel id="type-label">Course</InputLabel>
          <Select
            labelId="type-label"
            id="type"
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value)}
          >
            <MenuItem value="MARATHON">MARATHON</MenuItem>
            <MenuItem value="SEUIL">SEMI-MARATHON</MenuItem>
            <MenuItem value="DIX">DIX KILOMETRES</MenuItem>
            <MenuItem value="CINQ">CINQ KILOMETRES</MenuItem>            
          </Select>
        </FormControl>

        <TextField  sx={{ minWidth: 100 }}
          id="hour"
          label="Heure"
          type="number"
          value={hour}
          onChange={(e) => {
            const value = Math.min(Math.max(parseInt(e.target.value, 10) || 0, 0), 8);
            setHour(value);
          }}
          inputProps={{ min: 0, max: 8 }}
        />

        <TextField  sx={{ minWidth: 100 }}
          id="minute"
          label="Minute"
          type="number"
          value={minute}
          onChange={(e) => {
            const value = Math.min(Math.max(parseInt(e.target.value, 10) || 0, 0), 59);
            setMinute(value);
          }}
          inputProps={{ min: 0, max: 59 }}
        />

        <TextField  sx={{ minWidth: 100 }}
          id="second"
          label="Seconde"
          type="number"
          value={second}
          onChange={(e) => {
            const value = Math.min(Math.max(parseInt(e.target.value, 10) || 0, 0), 59);
            setSecond(value);
          }}
          inputProps={{ min: 0, max: 59 }}
        />

        <TextField sx={{ minWidth: 170 }}
          id="date"
          label="Date du record"
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ max: aujourdhui() }}
          required
        />

          <Button type="submit" variant="contained" sx={{ mt: 2 }}>Enregistrer le record</Button>

      </div>

    </form>
  );
};
